import en from './en.json';
export const translationsList = {
    ar: async () => import(/* webpackChunkName: "locale-ar" */ './ar.json'),
    de: async () => import(/* webpackChunkName: "locale-de" */ './de.json'),
    el: async () => import(/* webpackChunkName: "locale-el" */ './el.json'),
    en: async () => en,
    es: async () => import(/* webpackChunkName: "locale-es" */ './es.json'),
    fi: async () => import(/* webpackChunkName: "locale-fi" */ './fi.json'),
    fr: async () => import(/* webpackChunkName: "locale-fr" */ './fr.json'),
    hi: async () => import(/* webpackChunkName: "locale-hi" */ './hi.json'),
    hr: async () => import(/* webpackChunkName: "locale-hr" */ './hr.json'),
    it: async () => import(/* webpackChunkName: "locale-it" */ './it.json'),
    ja: async () => import(/* webpackChunkName: "locale-ja" */ './ja.json'),
    ko: async () => import(/* webpackChunkName: "locale-ko" */ './ko.json'),
    nl: async () => import(/* webpackChunkName: "locale-nl" */ './nl.json'),
    pl: async () => import(/* webpackChunkName: "locale-pl" */ './pl.json'),
    pt: async () => import(/* webpackChunkName: "locale-pt" */ './pt.json'),
    ro: async () => import(/* webpackChunkName: "locale-ro" */ './ro.json'),
    ru: async () => import(/* webpackChunkName: "locale-ru" */ './ru.json'),
    sv: async () => import(/* webpackChunkName: "locale-sv" */ './sv.json'),
    uk: async () => import(/* webpackChunkName: "locale-uk" */ './uk.json'),
    ur: async () => import(/* webpackChunkName: "locale-ur" */ './ur.json'),
    vi: async () => import(/* webpackChunkName: "locale-vi" */ './vi.json'),
    'zh-CN': async () => import(/* webpackChunkName: "locale-zh-CN" */ './zh_CN.json'),
    'zh-TW': async () => import(/* webpackChunkName: "locale-zh-TW" */ './zh_TW.json'),
};
//# sourceMappingURL=translationsList.js.map